import {notifications} from '@mantine/notifications';
import {
  COLOR_SUCCESS_1,
  COLOR_SUCCESS_2,
} from '../../../config/constants/colorCodes';

const PLACEHOLDER_TITLE = '保存しました';
const PLACEHOLDER_MESSAGE = 'Done';

type Props = {
  title?: string;
  message?: string;
};

export const showSuccessSnackBar = ({
  title = PLACEHOLDER_TITLE,
  message = PLACEHOLDER_MESSAGE,
}: Props) => {
  notifications.show({
    title,
    message,
    styles: () => ({
      root: {
        backgroundColor: COLOR_SUCCESS_1,
        borderColor: COLOR_SUCCESS_1,
        color: '#fff',
        '&::before': {backgroundColor: '#fff'},
      },
      title: {color: '#fff'},
      description: {color: '#fff'},
      closeButton: {
        color: '#fff',
        '&:hover': {backgroundColor: COLOR_SUCCESS_2},
      },
    }),
  });
};
